/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button, Flex, Text } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import execute from 'solis/claude/action/execute';

import Rpc from 'fierry/rpc';


const OnCommit = (event, type, args, client, onSuccess) =>
{
  execute(client, type, args, onSuccess);
};


const Issues = ({ issues }) =>
(
  <Flex direction = 'column' gap = '1'>
    {issues.map(issue => <Text key = {issue} size = '1' color = 'red'>{issue}</Text>)}
  </Flex>
);


// The shared tail of every action: its validation issues and the commit button that fires
// the assembled args through the single execute seam. Used by ActionCard and the attach pane.
export default ({ type, args, valid, issues, onSuccess, label = 'Commit' }) =>
{
  const client = use(Rpc);

  const onCommit = useCallback(OnCommit, [ type, args, client, onSuccess ]);

  return (
    <>
      {issues.length > 0 && <Issues issues = {issues} />}

      <Flex justify = 'end'>
        <Button disabled = {!valid} onClick = {onCommit}>{label}</Button>
      </Flex>
    </>
  );
};
